module.exports = __webpack_public_path__ + "static/media/mobile-menu-bg.fe6471dc.svg";